document.addEventListener('DOMContentLoaded', (event) => {
  const items = document.querySelectorAll('.mediatheque__item div');
  const popup = document.getElementById('popup-form');
  const closeBtn = document.getElementById('close-popup');
  const hiddenField = document.getElementById('wpforms-601-field_5');

  items.forEach((item) => {
    item.addEventListener('click', () => {
      const encodedLink = item.getAttribute('data-link');
      hiddenField.value = encodedLink;
      popup.style.display = 'block';
    });
  });

  closeBtn.addEventListener('click', () => {
    popup.style.display = 'none';
  });
});
